import styled from 'styled-components';
import { useRef, useEffect } from 'react';
import React from 'react';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';
import { hapticsImpactLight } from '../../common/haptic';

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  @media ${PHONE_MEDIA_QUERY} {
    position: unset;
  }
`;

const DropdownContent = styled.div`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 285px;
  padding: 16px 0;
  background: ${({ theme }) => theme.background.primary};
  border-radius: 16px;
  box-shadow:
    0px 8px 20px 0px ${({ theme }) => theme.text.title}14,
    0px 12px 32px 4px ${({ theme }) => theme.text.title}0a;
  z-index: 1000;
  @media ${PHONE_MEDIA_QUERY} {
    padding-top: 0px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    top: calc(100% - 1px);
    left: -16px;
    box-shadow: unset;
    width: 100vw;
  }
`;

const ChevronIcon = styled.img`
  transition: transform 0.2s ease-in-out;
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const Dropdown = ({ trigger, children, isOpen, setIsOpen }) => {
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    hapticsImpactLight();
  }, [isOpen]);

  return (
    <DropdownContainer ref={modalRef}>
      <TriggerContainer
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        {trigger}
        <ChevronIcon
          src='/chevron-down.svg'
          alt='Toggle menu'
          $isOpen={isOpen}
        />
      </TriggerContainer>
      <DropdownContent isOpen={isOpen}>{children}</DropdownContent>
    </DropdownContainer>
  );
};

export default Dropdown;
